//TopBar.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Dehaze";
import HelpOutline from "@material-ui/icons/HelpOutline";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar";
import userImg from "imgs/user.jpg";
import Settings from "components/Settings";
import Server from "components/Server";
import Snackbar from "components/Snackbar";
import Search from "components/Search";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import Common from "./Common";

const styles = {};

const classes = StyleSheet.create({
	topBar: {
		width: "100%",
		height: "100%",
		backgroundColor: "white",
		position: "relative",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	logo: {
		height: "100%",
		display: "flex",
		width: "110px",
		minWidth: "70px",
		marginLeft: "4.3rem",
		marginBottom: "0.2rem",
		justifyContent: "felx-start",
		alignItems: "center",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundImage: 'url("images/lofo_editea.jpg")'
	},
	buttons: {
		display: "flex",
		flex: "0 0 auto",
		justifyContent: "flex-end",
		height: "100%",
		alignItems: "center",
		paddingRight: "3vw",
		right: "0px"
	},
	leftButtons: {
		display: "flex",
		flex: "0 0 auto",
		height: "100%",
		alignItems: "center",
		paddingLeft: "1vw"
	},
	userButtonBox: {
		marginLeft: "10px"
	},
	userButton: {
		width: "40px",
		height: "40px",
		minWidth: "40px",
		backgroundColor: "transparent",
		borderRadius: "100px"
	},
	avatar: {
		position: "absolute",
		top: "0px"
	},
	UserButtonMenuItemfocus: {
		textAlign: "center",
		minWidth: "80px",
		display: "flex",
		alignItems: "center",
        justifyContent: "center",
        padding: "10px 35px",
		":focus": {
			backgroundColor: "white"
		},
		":hover": {
			backgroundColor: "rgba(0, 0, 0, 0.12)"
		}
    },
    UserButtonMenuItemfocusLogout: {
		textAlign: "center",
		minWidth: "80px",
		display: "flex",
		alignItems: "center",
        justifyContent: "center",
        padding: "10px 35px",
		":focus": {
			backgroundColor: "white"
		},
		":hover": {
            color: "white",
			backgroundColor: "#e74c3c"
		}
	},
	helpMessageTextField: {
		minWidth: "400px"
	}
});

class TopBar extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			openUserButtonMenu: false,
			anchorEl: null,
			dialogs: {
				settings: false
			},
			categories: true,
			openHelpDialog: false,
			helpMessageValue: null,
			helpMessageType: "question"
		};

		this.closeHelpDialog = this.closeHelpDialog.bind(this);
		this.sendHelpMessage = this.sendHelpMessage.bind(this);
	}

	closeHelpDialog() {
		this.setState({ openHelpDialog: false });
	}

	handleChange = name => event => {
		this.setState({
			[name]: event.target.value
		});
	};

	helpMessageTypeOnChange = event => {
		this.setState({ helpMessageType: event.target.value });
	};

	sendHelpMessage() {
		let demo = Common.isDemo();
		if (demo) {
			Snackbar.warning(
				"Message was not sent! Demo user can't use Help Center"
			);
			this.closeHelpDialog();
			return;
		}
		let message = this.state.helpMessageValue;
		if (message == null || message.length == 0) {
			Snackbar.error(
				"We really want to help you, please explain yourself..."
			);
			return;
		}

		this.closeHelpDialog();
		Snackbar.info(
			"Thanks! Message was sent, we will response as fast as possible"
		);
		Server.post(
			"/helpcenter/sendmessage",
			{
				message_type: this.state.helpMessageType,
				message: this.state.helpMessageValue
			},
			this.sendHelpMessageDone
		);
		this.setState({ helpMessageType: "question", helpMessageValue: null });
	}

	sendHelpMessageDone() {}

	renderHelpDialog() {
		return (
			<Dialog
				open={this.state.openHelpDialog}
				onClose={this.closeHelpDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">Help Center</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description" />
					<span style={{ marginRight: "15px" }}>
						What you want to share with us?
					</span>
					<Select
						value={this.state.helpMessageType}
						onChange={this.helpMessageTypeOnChange}
						displayEmpty
						name="helpMessageType"
					>
						<MenuItem value={"question"}>Question</MenuItem>
						<MenuItem value={"features"}>Features</MenuItem>
						<MenuItem value={"bug"}>Bug</MenuItem>
						<MenuItem value={"thanks"}>Thanks</MenuItem>
						<MenuItem value={"other"}>Other</MenuItem>
					</Select>
					<p />
					<TextField
						id="outlined-multiline-static"
						classes={{
							root: css(classes.helpMessageTextField)
						}}
						label="Explain yourself"
						multiline
						rows={7}
						rowsMax={7}
						value={this.state.helpMessageValue}
						onChange={this.handleChange("helpMessageValue")}
						margin="normal"
						variant="outlined"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.closeHelpDialog} color="primary">
						Not now
					</Button>
					<Button
						onClick={this.sendHelpMessage}
						color="secondary"
						variant="contained"
					>
						Send message
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	renderCategoriesButton() {
		return null;
		return (
			<div className={css(classes.leftButtons)}>
				<Button
					aria-label="Dehaze"
					onClick={this.toggleCategories.bind(this)}
				>
					<DeleteIcon />
				</Button>
			</div>
		);
	}

	renderButtons() {
		if (this.props.showButtons == false) return null;
		return (
			<div className={css(classes.buttons)}>
				<Button
					key={"helpme"}
					aria-label="Dehaze"
					onClick={() => this.setState({ openHelpDialog: true })}
				>
					<HelpOutline id="helpme" />
				</Button>
				{this.renderHelpDialog()}
				{this.userButton()}
			</div>
		);
	}

	userButton() {
		return (
			<div id="userButton" className={css(classes.userButtonBox)}>
				<Button
					classes={{ root: css(classes.userButton) }}
					color="primary"
					aria-owns={
						this.state.openUserButtonMenu ? "UserButtonMenu" : null
					}
					aria-haspopup="true"
					onClick={this.handleClick}
				>
					<Avatar
						classes={{ root: css(classes.avatar) }}
						sizes={"25px"}
						src={userImg}
					/>
				</Button>
				<Menu
					id="UserButtonMenu"
					anchorEl={this.state.anchorEl}
					open={this.state.openUserButtonMenu}
					onClose={this.handleRequestClose}
				>
					<MenuItem
						classes={{
							root: css(classes.UserButtonMenuItemfocus)
						}}
						onClick={() => {
							this.handleRequestClose();
							this.openSettings();
						}}
					>
						Settings
					</MenuItem>
					<MenuItem
						classes={{
							root: css(classes.UserButtonMenuItemfocusLogout)
						}}
						onClick={() => {
							this.handleRequestClose();
							this.logout();
						}}
					>
						Logout
					</MenuItem>
				</Menu>
			</div>
		);
	}

	logout() {
        Snackbar.info("Bye Bye :-)");
		Server.post("/logout", null, this.logoutDone.bind(this));
	}

	logoutDone() {
        setTimeout(() => {
		    window.location.reload();
        }, 500);
	}

	handleClick = event => {
		this.setState({
			openUserButtonMenu: true,
			anchorEl: event.currentTarget
		});
	};

	handleRequestClose = () => {
		this.setState({ openUserButtonMenu: false });
	};

	openSettings() {
		this.setState({ dialogs: { settings: true } });
	}

	closeSettings() {
		this.setState({ dialogs: { settings: false } });
	}

	openCategories() {
		this.setState({ categories: true });
	}

	closeCategories() {
		this.setState({ categories: false });
	}

	toggleCategories() {
		this.setState({ categories: !this.state.categories });
	}

	renderLogo() {
		return <div className={css(classes.logo)} />;
	}

	render() {
		return (
			<div style={this.props.style}>
				<div className={css(classes.topBar)}>
					{this.renderLogo()}
					{this.renderCategoriesButton()}
					{<Search />}
					{this.renderButtons()}
				</div>
				{this.props.showButtons && (
					<Settings
						open={this.state.dialogs.settings}
						onOpen={this.openSettings.bind(this)}
						onClose={this.closeSettings.bind(this)}
					/>
				)}
			</div>
		);
	}
}

export default TopBar;
